import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import styled from 'styled-components'

import { FlexBox } from '../../../components/Base/FlexBox'
import { Grid } from '../../../components/Base/Grid'
import { Text } from '../../../components/Text/Text'
import { blueGray, primaryBlack, white } from '../../../theme/colors'
import { ScorePill } from './ScorePill'

export function OverviewSidebarScore({
  title,
  tooltip,
  score,
  onClick,
}: {
  title: string
  tooltip: React.ReactNode
  score: {
    score?: number | null
    scoreColor?: string | null
    scoreBackgroundColor?: string | null
    scoreLabel?: string | null
    isPercentage?: boolean
  }
  onClick: () => void
}) {
  return (
    <SidebarScoreContainer columns="2fr 3fr" gap="16px">
      <FlexBox gap="8px" alignItems="center">
        <Text variant="uppercaseLabel3">{title}</Text>
        {tooltip}
      </FlexBox>
      <FlexBox gap="16px" alignItems="center" isFullHeight>
        <FlexBox gap="16px" alignItems="center" flex={1} isFullHeight>
          <ScorePill
            score={score?.score}
            color={score?.scoreColor}
            backgroundColor={score?.scoreBackgroundColor}
            isPercentage={score?.isPercentage}
          />
          <Text variant="header2" fontColor={primaryBlack} mt={0.5} styles="font-size: 16px; flex: 1;">
            {score?.scoreLabel}
          </Text>
        </FlexBox>
        <ArrowContainer onClick={onClick}>
          <KeyboardArrowRightIcon htmlColor={blueGray} />
        </ArrowContainer>
      </FlexBox>
    </SidebarScoreContainer>
  )
}

const SidebarScoreContainer = styled(Grid)`
  background-color: ${white};
  padding: 16px 0 16px 40px;
  margin-bottom: 2px;
`

// Have the arrow container be 100px wide and 100% height of the parent container
// Parent has 16px padding, add negative margin and extra height
const ArrowContainer = styled(FlexBox)`
  cursor: pointer;
  width: 100px;
  height: calc(100% + 32px);
  margin: -16px 0;
  padding: 0 40px;
  justify-content: flex-end;
  align-items: center;
`
